<template>
  <div class="home">
    <div class="top">
    </div>
    <div class="details">
      <div style="padding-top: 2rem">
        <el-tabs v-model="activeName" @tab-click="handleClick" style="width: 90%;margin-left: 5%">
          <el-tab-pane label="公司概况" name="first">
            <div>
              <div class="title">
                企业概况
              </div>
              <div style="display: flex">
                <div class="name">COMPANY PROFILE</div>
                <div style="width: 70%">
                  <el-divider></el-divider>
                </div>
              </div>
              <div class="font">
                <div class="text-indent">内投集团公司成立于2008年7月，注册资本金7.1亿元，是由市委、市政府出资设立的AA级信用评级国有企业。公司主要经营范围为：城市基础设施、交通、水务、能源、旅游、金融、农业、土地一级整理、房地产开发、矿产资源开发和市政府授权的其他领域的投资。
                截至2023年3月底，内投集团公司全资和控股子（分）公司员工总数1493人（不含劳务派遣、临聘、返聘），其
                班子情况。集团本部领导班子核定职数9人，实际在职7人。其中党委书记、董事长1人，党委副书记、总经理、董事1人，党委委员、纪委书记1人，副总经理2人，财务总监1人，工会主席、总经理助理1人。
                </div>
                <div class="text-indent"> 部门设置：集团本部设部门10个，分别为党群工作部、纪检监察室、综合办公室、财务管理部、人力资源部、风控审计部、融资部、经营管理部、投资合约部、安全环境与工程管理部。</div>
                <div class="text-indent">党组织情况：公司党委下设党总支2个（文旅公司党总支、保安公司党总支），党支部5个（机关党支部、彩色鱼党支部、国联公司党支部、云领智城公司党支部、蓉欧公司党支部），现有党员159名。集团下属国资公司、水务公司、能投公司、嘉宏公司党组织由市国资委党委直接管理。
                内投集团公司围绕“做大产业、做强物流、做优资本”，重点布局五大产业板块，以科技创新为引领，走生态优先绿色发展之路，力争“十四五”末，集团公司资产规模达600亿元，实现营收60亿元以上，利税超过5亿元，基本建立适应高质量发展的现代企业制度，为内江经济社会发展贡献企业力量。
                </div>
                <div class="text-indent">内投集团公司围绕“做大产业、做强物流、做优资本”，重点布局五大产业板块，以科技创新为引领，走生态优先绿色发展之路，力争“十四五”末，集团公司资产规模达600亿元，实现营收60亿元以上，利税超过5亿元，基本建立适应高质量发展的现代企业制度，为内江经济社会发展贡献企业力量。</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="公司领导" name="second" style="min-height: 30rem">
            <div>
              <div class="title">
                公司领导
              </div>
              <div style="display: flex">
                <div class="name">COMPANY LEADERSHIP</div>
                <div style="width: 70%">
                  <el-divider></el-divider>
                </div>
              </div>
              <div style="margin-top: 80px">
                <div class="people">
                  <div v-if="people">
                    <img :src="people.photo" class="img">
                    <div>{{people.leaderName}}</div>
                    <div>{{ people.posts }}</div>
                  </div>
                </div>
                <div class="people" v-if="peopleList.length>0">
                  <div v-for="item in peopleList" :key="item.id" style="padding: 3rem">
                    <img :src="item.photo" class="img">
                    <div>{{item.leaderName}}</div>
                    <div>{{ item.posts }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="发展历程" name="third">
            <div>
              <div class="title">
                发展历程
              </div>
              <div style="display: flex">
                <div class="name">Development History</div>
                <div style="width: 70%">
                  <el-divider></el-divider>
                </div>
              </div>
              <div style="display: flex">
                  <div class="inner" style="height: 800px">
                    <div style="overflow: hidden;width: 100%"
                         class="list"
                         v-infinite-scroll="load"
                         :infinite-scroll-disabled="disabled">
                      <div style="width: 100%">
                        <el-timeline style="width: 100%" >
                          <el-timeline-item   :class="['details_date',index % 2 === 0 ? 'odd-item': '',]" v-for="(item, index) in dateList" :timestamp="item.summary" :key="index" placement="top" >
                            <el-card :body-style="{width:'100%'}" :class="item.isHovered ? 'hover-shadow':''">
                              <div @mouseenter="changeShadow(item)" @mouseleave="changeShadow(item)" class="content" :style="{color:item.isHovered ? '#1196db':''}" v-html="item.content"></div>
                            </el-card>
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>
                    <p style="text-align: center;width: 100%" v-if="loading">加载中...</p>
                    <p style="text-align: center;width: 100%" v-if="noMore">没有更多了</p>
                  </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="组织结构" name="fourth">
            <div class="overflow-scroll" >
              <el-image :src="require('@/assets/image/NTorganization.png')"  :style="{ transform: `scale(${scaleFactor})`,'transform-origin': 'left top',}"
                        @wheel.prevent="handleWheel">
              </el-image>
            </div>
<!--            <div style="height: 1px;background-color: #bfbfbf;margin-top: 20px"></div>-->
            <div style="display: flex;margin-top: 40px" @mouseenter="changeSize()" @mouseleave="changeSize()">
              <div style="width: 50%">
                <div style="margin-left: 100px;color: #007fff;font-size: 26px">治理机制</div>
                <div style="margin-left: 50px;color: #bfbfbf;font-size: 16px;margin-top: 10px">GOVERNANCE MECHANISM</div>
                <div  style="font-family:'宋体';line-height: 1.1rem; margin-left: 50px;margin-top: 10px">
                  内投集团自成立以来，经过不懈的探索，逐步建立起一套以服务公司发展战略为核心，党委会、董事会、经营班子分工明确、协调配合、治理有效的公司管理体制与运作机制。<br>
                  内投集团始终将规范运作、安全运行作为公司的“生命线”， 坚持以习近平新时代中国特色社会主义思想为指导，认真贯彻落实省委、省政府和省国资委关于法治建设的决策部署，全面深化法制建设，勇当法治国企排头兵。坚持制度先行，深入推进第一责任人职责落实，不断加强法治建设顶层设计，建立健全工作推进机制，筑牢公司高质量发展的法治根基；聚焦风险防范，创新建立风险防范组织体系、 全面加强合规管理建设并建立“五大联动”工作体系，构建公司务实管用的法务合规体系；着眼价值创造，通过法务支撑改革更加到位、保障企业发展更加有力以及依法积极维权来着力推动法治与改革发展深度融合；坚持文化先导，着力培育和弘扬法治国企先进文化，着力抓企业法治能力提升、抓企业法治文化建设以及抓法治建设重大问题研究。<br>
                  下一步内投集团将继续坚持以制度建设、风险管控、绩效管理为重点，以企业法治建设为保障，着力构建科学高效、规范有序的运行机制，不断提升公司可持续健康发展的能力，为打造具有国际竞争力的世界一流企业、推动治蜀兴川再上新台阶而努力。
                </div>
              </div>
              <div style="width: 50%">
                <el-image :src="orgSrc" style="margin-left: 10%;margin-top: 5rem" :style="{
              transform: status ? 'scale(1.05)' : 'scale(1)',
              transition: 'transform 0.5s ease'
            }"></el-image>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {getLeaderList} from "@/api/leader";
import {getArticleDetailList} from "@/api/article";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'about',
  components: {
  },
  computed:{
    noMore () {
      return this.dateList.length==this.articleTotal
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  data(){
    return {
      status:false,
      scaleFactor: 1,
      orgSrc:require('@/assets/image/organization.png'),
      // pdfSrc: require('@/assets/image/NTorganization.png'),
      lastArticle:undefined,
      articleTotal:0,
      queryLeader: {
        status:true
      },
      queryArticle: {
        status:true,
        category:2,
        pageNum: 1,
        pageSize: 10,
      },
      loading:false,
      dataDetailes:undefined,
      dateList:[],
      activeName:'first',
      people:undefined,
      peopleList:[]
    }
  },
  mounted() {

  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置到 Vue Router 的 meta 字段
    if (this.$el) {
      from.meta.savedPosition = {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    next();
  },
  methods: {
    changeSize(){
      this.status=!this.status
    },
    changeShadow(item) {
      item.isHovered = !item.isHovered;
    },
    handleWheel(event){
      // 阻止默认滚动行为（如果需要）
      event.preventDefault();

      // 获取滚动方向和滚动量
      const delta = event.deltaY || event.deltaX; // deltaY 用于垂直滚动，deltaX 用于水平滚动
      const isScrollingUp = delta > 0 ? false : true; // 根据delta值判断滚动方向
      if(isScrollingUp){
        this.zoomOut()
      }else if(!isScrollingUp){
        this.zoomIn()
      }
    },
    zoomIn() {
      this.scaleFactor *= 1.1; // 放大图片
       },
    zoomOut() {
      this.scaleFactor /= 1.1; // 缩小图片
       },
    // getDetails(item){
    //   if (this.lastArticle){
    //     this.lastArticle.style="font-size: 24px;color: #707070"
    //   }
    //   item.style="font-size: 30px;color: #3f9dfe"
    //   this.lastArticle=item
    //   getArticle({id:item.id}).then(res=>{
    //     this.dataDetailes=res.data.content
    //   })
    // },
    getPeopleList(){
      getLeaderList(this.queryLeader).then(res=>{
        const data=res.data.content
        this.peopleList=[]
        for (let i = 0; i < data.length; i++) {
          if(i==0){
            this.people=data[i]
          }else {
            this.peopleList.push(data[i])
          }
        }
      })
    },
    getArticleList(){
      getArticleDetailList(this.queryArticle).then(res=>{
        this.loading=false
        const data =res.data.content
        this.articleTotal=res.data.totalElements
            for (let i = 0; i < data.length; i++) {
              data[i].isHovered=false
              this.dateList.push(data[i])
            }
      })
    },
    load () {
      this.loading = true
      this.queryArticle.pageNum++
      this.getArticleList()
    },
    handleClick(tab) {
      if(tab.name=='second'){
        this.peopleList=[]
        this.getPeopleList()
      }else if(tab.name=='third'){
        this.dateList=[]
        this.getArticleList()
      }
    }
  }
}
</script>

<style scoped>
::v-deep .el-timeline {
  padding-left: 50%;
}
.hover-shadow {
  /* 鼠标悬停时的阴影效果 */
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2);
}
.content{
  width: 93%;overflow-wrap: break-word; text-align: left
}
.details_date{
  width: 50%;
  text-align: left;
  font-weight: bold
}
.odd-item > ::v-deep .el-timeline-item__wrapper{
  left: -104%;
  text-align: right;
}
::v-deep(.el-timeline-item) .el-timeline-item__timestamp {
  font-size: 30px; /* 修改为你希望的字体大小 */
  color: #007fff;
  padding-right: 20px;
  padding-left: 20px;
}
.overflow-scroll {
  width: 100%; /* 或者具体的宽度值，如 300px */
  overflow-x: auto; /* 当内容溢出时显示滚动条 */
}
.inner {
  /*margin-left: 50px;*/
  overflow: auto;
}
.inner::-webkit-scrollbar {
  width: 0 !important;
}
.date{
  display: flex;
  height: 80px;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.img{
  width: 200px;
  height: 230px;
  color: #707070;
}
.people{
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;
}
.home{
  padding-top: 4rem;
  width: 100%;
  background-color: #efefef;
}
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}
.text-indent {
  text-indent: 2em;
  font-size: 1rem;
  line-height: 1.8rem;
}
.title {
  margin-top: 40px;
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 30%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 10px;
}
.font{
  width: 90%;
  margin-left: 5%;
  margin-top: 1rem;
  font-family: '宋体', sans-serif;
  font-weight: bold;
  font-style: normal;
  font-size: 6rem;
  letter-spacing: 0.5px;
  text-align: left;
  line-height: 1.5rem;
  padding-bottom: 3rem;
}
</style>
